import styles from './TextDisplaySidebar.module.css';

import { useEffect, useRef, useState } from 'react';
import InternalLinksBox from '../TextDisplay/InternalLinksBox';
import { SemanticResultsBox } from './SemanticResultsBox';
import { KeywordBox } from './KeywordBox';
import { StuffedKeywordsBox } from './StuffedKeywordsBox';
import { KeywordGenerationButton } from './KeywordGenerationButton';
import { forwardRef } from 'react';
import { ROLES } from 'utils/Constants';
import { setKeyWordList } from 'helpers/PdfFunction';

import ScoringSectionContainer from './ScoringSectionContainer';

export const TextDisplaySidebar = forwardRef(
  (
    {
      collapsed,
      setCollapsed,
      width = 424,
      minWidth = 424,
      maxWidth = 500,
      setWidth,
      analyseResult,
      loading,
      combinedKeywords,
      keywords,
      handleKeywordChange,
      isKeywordBoxReadOnly,
      orderContentType,
      stuffedKeywords,
      autoKeywordsGenerationLoading,
      onGenerateKeywords,
      websites,
      actualHtmlContent,
      actualTextContent,
      initialTextContent,
      handleInputChange,
      userRole,
      orderWebsite,
      country,
      keyword,
      url,
      t,
      initialStuffedKeywords,
      list,
      language,
      maxWords,
      wordCount,
      keywordStuffingLoading,
      checkIfAllLinesGreen,
      isDelivered,
      renderAnalyseText,
      initialContentScore,

      mode = 'admin',
      textId,
      preCalculatedScoreData,
      onScoreDataChange,
      defaultScoreTab,
      handleGapUpdate,

      uiOnly = false,
      isActive = true,
      showToggle = true,
      animateWidth = true,
    },
    ref
  ) => {
    const [isEditing, setIsEditing] = useState(false);

    const isResizing = useRef(false);

    const handleMouseDown = () => {
      isResizing.current = true;
      document.body.classList.add('resizing');
    };

    const handleMouseMove = (event) => {
      if (!isResizing.current || collapsed) return;

      document.body.classList.add('resizing');

      const calculatedWidth = window.innerWidth - event.clientX;
      const newWidth = Math.min(maxWidth, Math.max(minWidth, calculatedWidth));

      setWidth(newWidth);
    };

    const handleMouseUp = () => {
      isResizing.current = false;
      document.body.classList.remove('resizing');
    };

    useEffect(() => {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }, []);

    return (
      <>
        {showToggle && (
        <button
          className={styles.sidebarToggleButton}
          style={{
            right: collapsed ? 5 : width + 5,
          }}
          onClick={() => setCollapsed(!collapsed)}
        >
          <img
            src={
              collapsed
                ? '/Images/icon-menu/icon-open-menu.png'
                : '/Images/icon-menu/icone-close-menu.png'
            }
            alt={collapsed ? 'Open sidebar' : 'Close sidebar'}
            style={{ width: 60, height: 60 }}
          />
        </button>
        )}

        <div
          className={styles.sidebar}
          style={{
            width: collapsed ? 0 : width,
            ...(animateWidth === false ? { transition: 'none' } : {}),
          }}
        >
          <div onMouseDown={handleMouseDown} className={styles.resizeHandler} />

          <div ref={ref} className={styles.sidebarContent}>
            {isActive && (uiOnly ? (
              <ScoringSectionContainer
                actualHtmlContent={actualHtmlContent}
                actualTextContent={actualTextContent}
                orderWebsite={orderWebsite}
                country={country}
                keyword={keyword}
                url={url}
                keywords={setKeyWordList(keywords)}
                isEditing={isEditing}
                websites={websites}
                setIsEditing={setIsEditing}
                handleInputChange={handleInputChange}
                checkIfAllLinesGreen={checkIfAllLinesGreen}
                userRole={userRole}
                language={language}
                maxWords={maxWords}
                wordCount={wordCount}
                isKeywordBoxReadOnly={isKeywordBoxReadOnly}
                combinedKeywords={combinedKeywords}
                handleKeywordChange={handleKeywordChange}
                orderContentType={orderContentType}
                autoKeywordsGenerationLoading={autoKeywordsGenerationLoading}
                isReadOnly={isKeywordBoxReadOnly}
                initialContentScore={initialContentScore}
                list={list}
                handleGapUpdate={handleGapUpdate}
                t={t}
                mode={'ui'}
                defaultScoreTab={defaultScoreTab || 'global'}
              />
            ) : (
              <ScoringSectionContainer
                actualHtmlContent={actualHtmlContent}
                actualTextContent={actualTextContent}
                initialTextContent={initialTextContent}
                orderWebsite={orderWebsite}
                country={country}
                keyword={keyword}
                url={url}
                keywords={setKeyWordList(keywords)}
                isEditing={isEditing}
                websites={websites}
                setIsEditing={setIsEditing}
                handleInputChange={handleInputChange}
                checkIfAllLinesGreen={checkIfAllLinesGreen}
                userRole={userRole}
                language={language}
                maxWords={maxWords}
                wordCount={wordCount}
                isKeywordBoxReadOnly={isKeywordBoxReadOnly}
                combinedKeywords={combinedKeywords}
                handleKeywordChange={handleKeywordChange}
                orderContentType={orderContentType}
                autoKeywordsGenerationLoading={autoKeywordsGenerationLoading}
                isReadOnly={isKeywordBoxReadOnly}
                initialContentScore={initialContentScore}
                list={list}
                handleGapUpdate={handleGapUpdate}
                t={t}

                mode={mode}
                textId={textId}
                preCalculatedScoreData={preCalculatedScoreData}
                onScoreDataChange={onScoreDataChange}
                defaultScoreTab={defaultScoreTab}
              />
            ))}
            {/* <SemanticResultsBox
              analyseResult={analyseResult}
              loading={loading}
              list={list}
            />

            <KeywordBox
              combinedKeywords={combinedKeywords}
              handleKeywordChange={handleKeywordChange}
              orderContentType={orderContentType}
              autoKeywordsGenerationLoading={autoKeywordsGenerationLoading}
              isReadOnly={isKeywordBoxReadOnly}
            />

            {userRole === ROLES.CLIENT && (
              <div className="d-flex justify-content-end mb-3">
                {renderAnalyseText && renderAnalyseText()}
              </div>
            )}

            {(userRole === ROLES.ADMIN || userRole === ROLES.WRITER) &&
              combinedKeywords.length > 0 && (
                <div className="d-flex justify-content-end mb-3">
                  {renderAnalyseText && renderAnalyseText()}
                </div>
              )}

            {((userRole === ROLES.ADMIN && orderContentType !== 'GMB') ||
              userRole === ROLES.WRITER) &&
              combinedKeywords.length === 0 && (
                <KeywordGenerationButton
                  t={t}
                  onGenerateKeywords={onGenerateKeywords}
                />
              )}

            {userRole !== ROLES.CLIENT &&
              !(userRole === ROLES.CONSULTANT && !isDelivered) && (
                <div
                  className="box-wrapper"
                  style={{
                    overflow: 'hidden',
                    wordWrap: 'break-word',
                  }}
                  onClick={() => setIsEditing(true)}
                >
                  <InternalLinksBox
                    isEditing={isEditing}
                    websites={websites}
                    actualHtmlContent={actualHtmlContent}
                    setIsEditing={setIsEditing}
                    handleInputChange={handleInputChange}
                    checkIfAllLinesGreen={checkIfAllLinesGreen}
                    userRole={userRole}
                    t={t}
                  />
                </div>
              )}

            {(userRole === ROLES.ADMIN ||
              (userRole === ROLES.WRITER && !(isDelivered ?? false)) ||
              (userRole === ROLES.CONSULTANT && !isDelivered)) &&
              (stuffedKeywords?.length || initialStuffedKeywords?.length) >
                0 && (
                <StuffedKeywordsBox
                  keywordStuffingLoading={keywordStuffingLoading}
                  stuffedKeywords={stuffedKeywords}
                  initialStuffedKeywords={initialStuffedKeywords}
                />
              )} */}
          </div>
        </div>
      </>
    );
  }
);

export default TextDisplaySidebar;

